import { IconButton, Tooltip } from '@mui/material';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

export type DeclaredRegStatus = 'declared' | 'registered' | 'add';

type Props = {
	status: DeclaredRegStatus;
	onAdd?: () => void;
	disabled?: boolean;
};

/**
 * Status zadeklarowany / zarejestrowany na liście uczniów nauczyciela.
 * - declared: tylko na liście deklaracji (niebieski pusty okrąg)
 * - registered: zadeklarowany i zarejestrowany (zielony check)
 * - add: zarejestrowany bez deklaracji — klik dopisuje do listy uczniów
 */
const DeclaredRegistrationStatusIcon = ({ status, onAdd, disabled }: Props) => {
	if (status === 'declared') {
		return (
			<Tooltip title='Zadeklarowany'>
				<span>
					<RadioButtonUncheckedIcon
						data-testid='declared-status-declared'
						sx={{ color: 'info.main', fontSize: 22 }}
						aria-label='Zadeklarowany'
					/>
				</span>
			</Tooltip>
		);
	}
	if (status === 'registered') {
		return (
			<Tooltip title='Zarejestrowany'>
				<span>
					<CheckCircleIcon
						data-testid='declared-status-registered'
						sx={{ color: 'success.main', fontSize: 22 }}
						aria-label='Zarejestrowany'
					/>
				</span>
			</Tooltip>
		);
	}
	return (
		<Tooltip title='Dodaj ucznia'>
			<span>
				<IconButton
					size='small'
					disabled={disabled}
					onClick={onAdd}
					aria-label='Dodaj ucznia'
					data-testid='declared-status-add'
					sx={{ color: 'warning.main', p: 0.25 }}
				>
					<AddCircleOutlineIcon sx={{ fontSize: 22 }} />
				</IconButton>
			</span>
		</Tooltip>
	);
};

export default DeclaredRegistrationStatusIcon;
